import { Controller, type Control, type FieldErrors } from 'react-hook-form';

import { TextArea } from '@common/ui/inputs/TextArea';
import { Heading } from '@common/ui/typography/Heading';
import { Paragraph } from '@common/ui/typography/Paragraph';

import {
  MAX_ABOUT_LENGTH,
  MIN_ABOUT_LENGTH,
} from '@entities/profile/constants';

import type { SignUpFormData } from '../../SignUp';

interface AboutProps {
  control: Control<SignUpFormData>;
  errors: FieldErrors<SignUpFormData>;
}

export const About = ({ control, errors }: AboutProps) => {
  return (
    <>
      <Heading level={2} style={{ textAlign: 'center' }}>
        Рассказ о себе
      </Heading>
      <Paragraph style={{ textAlign: 'center', marginTop: -20 }}>
        95% пользователей обращает внимание только на анкеты с описанием
      </Paragraph>

      <Controller
        control={control}
        name="about"
        render={({ field }) => (
          <TextArea
            required
            placeholder="Напишите о себе подробнее"
            description={`Не меньше ${MIN_ABOUT_LENGTH} и не больше ${MAX_ABOUT_LENGTH} символов`}
            value={field.value || ''}
            onReset={() => field.onChange('')}
            onChange={(e) => field.onChange(e.target.value)}
            error={errors.about?.message?.toString()}
            maxLength={MAX_ABOUT_LENGTH}
            onBlur={() => field.onBlur()}
          />
        )}
      />
    </>
  );
};
